import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ChartOptions, ChartType, ChartData } from 'chart.js';
import { NgChartsModule } from 'ng2-charts';
import { PieChartWidgetData } from 'src/app/core/providers/dashboardWidget/dashboardWidget.models';

@Component({
  selector: 'app-pie-chart',
  standalone: true,
  imports: [NgChartsModule],
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
})
export class PieChartComponent implements OnInit, OnChanges {
  @Input() widgetData!: PieChartWidgetData;
  title?: string = '';
  
  get statistics() {
    return this.widgetData?.statistics || [];
  }
  
  get hasChartData(): boolean {
    if (!this.pieChartData) {
      return false;
    }
    return (
      Array.isArray(this.pieChartData.labels) &&
      this.pieChartData.labels.length > 0 &&
      Array.isArray(this.pieChartData.datasets) &&
      this.pieChartData.datasets.length > 0 &&
      this.pieChartData.datasets[0]?.data?.length > 0
    );
  }
  
  // Explicitly type as 'pie' instead of ChartType
  pieChartType: 'pie' = 'pie';
  
  pieChartOptions: ChartOptions<'pie'> = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: { top: 10, bottom: 10, left: 10, right: 10 }
  },
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      padding: 8,
      caretPadding: 4,
      displayColors: false,
      bodyFont: {
        size: 8,
        family: 'Roboto, sans-serif'
      },
      titleFont: {
        size: 10,
        family: 'Roboto, sans-serif',
        weight: 'bold'
      },
      backgroundColor: 'rgba(0,0,0,0.8)',
    }
  },
  animation: {
    animateScale: true,
    animateRotate: true
  }
};



  pieChartData: ChartData<'pie'> = {
    labels: [],
    datasets: [{ data: [], backgroundColor: [] }],
  };

  ngOnInit() {
    this.initWidgetData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['widgetData'] && !changes['widgetData'].firstChange) {
      this.widgetData = { ...this.widgetData };
      this.initWidgetData();
    }
  }

  initWidgetData(): void {
    if (this.widgetData && this.widgetData.labels && this.widgetData.values) {
      this.title = this.widgetData.title;
      const defaultColors = [
        '#4e79a7',
        '#f28e2b',
        '#e15759',
        '#76b7b2',
        '#59a14f',
        '#edc949',
        '#af7aa1',
        '#ff9da7',
        '#9c755f',
        '#bab0ab',
      ];

      this.pieChartData = {
        labels: [...(this.widgetData.labels || [])],
        datasets: [
          {
            data: [...(this.widgetData.values || [])],
            backgroundColor:
              this.widgetData.backgroundColor?.length === this.widgetData.values.length
                ? this.widgetData.backgroundColor
                : defaultColors.slice(0, this.widgetData.values.length),
            borderWidth: 1,
            borderColor: '#fff',
          },
        ],
      };
    } else {
      // Réinitialiser si pas de données
      this.pieChartData = {
        labels: [],
        datasets: [{ data: [], backgroundColor: [] }],
      };
    }
  }

  getTotalValue(): number {
    if (this.pieChartData.datasets && this.pieChartData.datasets[0]) {
      return this.pieChartData.datasets[0].data.reduce((sum: number, value: number) => sum + value, 0);
    }
    return 0;
  }
}
